import { BiQueryProps, RenderQuery } from "#next/components/base/RenderQuery";
import {
  FormModalLoading,
  FormModalWithErrorMessage,
} from "#next/components/modals/FormModal";
import {
  InferQueryLikeData,
  InferQueryLikeInput,
  QueryLike,
} from "@trpc/react-query/dist/shared";
import { UseTRPCQueryOptions } from "@trpc/react-query/shared";

type SharedProps = {
  title: string;
  open: boolean;
  onClose: (didSave: boolean) => void;
};

export function RenderQueryFormModal<
  T extends QueryLike,
  T2 extends QueryLike,
  G extends InferQueryLikeInput<T>,
  G2 extends InferQueryLikeInput<T2>,
  O extends UseTRPCQueryOptions<any, any, any, any, any>,
  O2 extends UseTRPCQueryOptions<any, any, any, any, any>,
  P extends InferQueryLikeData<T>,
  P2 extends InferQueryLikeData<T2>,
>(props: SharedProps & BiQueryProps<T, T2, G, G2, O, O2, P, P2>): JSX.Element;
export function RenderQueryFormModal<
  T extends QueryLike,
  T2 extends QueryLike,
  G extends InferQueryLikeInput<T>,
  G2 extends InferQueryLikeInput<T2>,
  O extends UseTRPCQueryOptions<any, any, any, any, any>,
  O2 extends UseTRPCQueryOptions<any, any, any, any, any>,
  P extends InferQueryLikeData<T>,
  P2 extends InferQueryLikeData<T2>,
>({
  title,
  open,
  onClose,
  useQuery,
  render,
  input,
}: SharedProps & BiQueryProps<T, T2, G, G2, O, O2, P, P2>) {
  const closedWithoutSaving = () => onClose(false);

  return (
    <RenderQuery
      useQuery={useQuery}
      render={render}
      input={input}
      renderLoading={() => (
        <FormModalLoading
          title={title}
          open={open}
          onClose={closedWithoutSaving}
        />
      )}
      renderError={() => (
        <FormModalWithErrorMessage
          title={title}
          open={open}
          onClose={closedWithoutSaving}
        />
      )}
    />
  );
}
